<script lang="ts">
  import { onMount } from "svelte"
  import Navigation from "./Navigation.svelte"
  import LongTermGoalForm from "$app/Pages/Plans/Onboarding/LongTermGoalForm.svelte"
  import bg from "@images/onboarding/bg-eclipse.jpg"
  import img from "@images/onboarding/lt_goal.png"
  import { onboardingStore } from "./onboarding.svelte"

  export let root_goal_id: number

  onboardingStore.completed = true

  onMount(() => {
    onboardingStore.setBrowserHistory({}, "long_term_goal")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step="long_term_goal" on:updateStep />
  </div>
  <div class="px-4 w-full lg:w-1/2 xl:pr-16">
    <LongTermGoalForm {root_goal_id} />
  </div>
</div>

<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-32 lg:-mb-32 rounded-tl-lg lg:-right-0 md:w-1/3 lg:w-1/2 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
  style="background-image: url({bg})"
>
  <img
    src={img}
    alt="Long Term Goal"
    class="absolute inset-0 inset-x-2 inset-y-2 xl:-inset-x-6 xl:inset-y-4 w-11/12 object-fill rounded shadow-lg"
  />
</div>
